export const EN_BENEFITS_STRINGS = {
  // Main entity labels
  BENEFITS_CONFIG_BENEFIT: 'Benefits Configuration',
  BENEFITS_CONFIG_BENEFIT_REQUEST: 'Benefits Configuration Request',
  BENEFITS_CONFIG_BENEFIT_ATTRIBUTES: 'Benefits Configuration Attributes',
  BENEFITS_CONFIG_ENTITY_METADATA: 'Entity Metadata',
  BENEFITS: 'Benefits',

  // Entity property labels
  BENEFITS_CONFIG_BENEFIT_ID: 'Configuration ID',
  BENEFITS_CONFIG_BENEFIT_TYPE: 'Resource Type',
  BENEFITS_CONFIG_BENEFIT_REQUEST_ID: 'Configuration ID',
  BENEFITS_CONFIG_BENEFIT_REQUEST_TYPE: 'Resource Type',

  // Metadata labels
  BENEFITS_CONFIG_NAME: 'Configuration Name',
  BENEFITS_CONFIG_STATUS: 'Status',
  BENEFITS_LAST_UPDATED_DATE: 'Last Updated Date',
  BENEFITS_LAST_PUBLISHED_DATE: 'Last Published Date',

  // Section labels
  BENEFITS_METADATA_LABEL: 'Metadata',
  BENEFITS_CONTENT_LABEL: 'Content',

  // Configuration controls
  BENEFITS_CONFIGURATION_SCOPE: 'Configuration Scope',
  BENEFITS_TARGET_IDENTIFIER: 'Target Identifier',
  BENEFITS_TITLE_CONTROL: 'Title',
  BENEFITS_SUBTITLE_CONTROL: 'Subtitle',
  BENEFITS_DESCRIPTION_CONTROL: 'Description',
  BENEFITS_READ_MORE_DESCRIPTION_CONTROL: 'Read More Description',

  // CTA Override labels
  BENEFITS_BENEFIT_CTA_OVERRIDE: 'CTA Configuration',
  BENEFITS_CTA_LABEL: 'CTA Label',
  BENEFITS_CTA_URL: 'CTA URL',
  BENEFITS_CTA_TRAILING_ICON: 'Trailing Icon',
  BENEFITS_IS_CTA_LABEL_GENERIC: 'Is CTA Label Generic',

  // Logo Override labels
  BENEFITS_BENEFIT_LOGO_OVERRIDE: 'Benefit Logo Configuration',
  BENEFITS_LOGO_TYPE: 'Logo Type',
  BENEFITS_LOGO_SOURCE: 'Logo Source',

  // Image Override labels
  BENEFITS_SPONSOR_LOGO_OVERRIDE: 'Sponsor Logo Configuration',
  BENEFITS_IMAGE_SOURCE: 'Image Source',
  BENEFITS_IMAGE_WIDTH: 'Image Width',
  BENEFITS_IMAGE_HEIGHT: 'Image Height',

  // Enum Labels
  BENEFITS_DRAFT: 'Draft',
  BENEFITS_PUBLISHED: 'Published',
  BENEFITS_UNPUBLISHED: 'Unpublished',
  BENEFITS_ARCHIVED: 'Archived',

  BENEFITS_EXTERNAL_LINK: 'External Link',
  BENEFITS_NEW_WINDOW_INTERNAL: 'New Window Internal',
  BENEFITS_NO_ICON: 'No Icon',

  BENEFITS_OVERRIDE_SPECIFIC_BENEFIT: 'Override Specific Benefit',
  BENEFITS_TEMPLATE_FOR_BENEFIT_TYPE: 'Template for Benefit Type',

  // Hint strings for basic fields
  BENEFITS_CONFIG_NAME_HINT:
    'Enter a descriptive name for this configuration to help identify it later',
  BENEFITS_CONFIG_STATUS_HINT:
    'Select the current status of this configuration (draft, published, etc.)',
  BENEFITS_LAST_UPDATED_DATE_HINT:
    'Shows when this configuration was last modified',
  BENEFITS_LAST_PUBLISHED_DATE_HINT:
    'Shows when this configuration was last published',

  BENEFITS_CONFIGURATION_SCOPE_HINT:
    'Choose whether to override a specific benefit or create a template for a benefit type',
  BENEFITS_TARGET_IDENTIFIER_HINT:
    'Enter the identifier value for the selected scope',

  // Content field hints
  BENEFITS_TITLE_HINT: 'Enter the title text to display for this benefit',
  BENEFITS_SUBTITLE_HINT: 'Enter the subtitle text to display for this benefit',
  BENEFITS_DESCRIPTION_HINT: 'Enter the main description text for this benefit',
  BENEFITS_READ_MORE_DESCRIPTION_HINT:
    'Enter extended description text shown when user requests more details',

  BENEFITS_CTA_LABEL_HINT:
    'Enter the text to display on the call-to-action button',
  BENEFITS_CTA_URL_HINT:
    'Enter the URL the button should navigate to when clicked',
  BENEFITS_CTA_TRAILING_ICON_HINT:
    'Choose an icon to display after the button text, if any',
  BENEFITS_IS_CTA_LABEL_GENERIC_HINT:
    'Check this if the button text is generic (like "Learn More") so it can be associated with the heading for accessibility',

  BENEFITS_LOGO_TYPE_HINT: 'The type of logo source (automatically set to URL)',
  BENEFITS_LOGO_SOURCE_HINT:
    'Upload an image file or enter a URL for the benefit logo',
  BENEFITS_LOGO_DESCRIPTION:
    'Alternative text for accessibility (important for screen readers)',
  BENEFITS_LOGO_DESCRIPTION_HINT:
    'Enter the alternative text for the benefit logo',

  BENEFITS_IMAGE_SOURCE_HINT:
    'Upload an image file or enter a URL for the sponsor logo',
  BENEFITS_IMAGE_WIDTH_HINT:
    'Specify the width in pixels for the logo (optional - leave blank for automatic sizing)',
  BENEFITS_IMAGE_HEIGHT_HINT:
    'Specify the height in pixels for the logo (optional - leave blank for automatic sizing)',
  BENEFITS_IMAGE_DESCRIPTION:
    'Alternative text for accessibility (important for screen readers)',
  BENEFITS_IMAGE_DESCRIPTION_HINT:
    'Enter the alternative text for the sponsor logo',
};
